import { render, staticRenderFns } from "./list.html?vue&type=template&id=7f8d4673&scoped=true&external"
import script from "./list.js?vue&type=script&lang=js&external"
export * from "./list.js?vue&type=script&lang=js&external"
import style0 from "./list.scss?vue&type=style&index=0&id=7f8d4673&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d4673",
  null
  
)

export default component.exports